import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import Button from '../../components/Button';
import AddDetails from '../studentDetails/AddDetails';
import { toast } from 'react-toastify';
import PushNotifications from './PushNotifications';
import Swal from 'sweetalert2';
import AddStudents from '../Students/AddStudents';
import Input from '../../components/Input';

const Dashboard = () => {
  const [request, setRequest] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [open, setOpen] = useState(false);
  const [courseId, setCourseId] = useState(null);
  const [state, setState] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCourses = request.filter((course) => {
    const matchesSearchQuery =
      course?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      course?.course?.name?.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearchQuery;
  });

  const [totalData,setTotalData] = useState({});
  const requestSubmit = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/user/admissionRequest', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const data = JSON.parse(result);
        console.log(data?.data);
        setRequest(data?.admissions || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const completedSubmit = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/total-students', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const data = JSON.parse(result);
        console.log(data?.data);
        setTotalData(data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    requestSubmit();
    completedSubmit();
  }, []);

  const handleAddDetails = (course) => {
    setOpen(true);
    console.log('Add details for', course?._id);
    setCourseId(course?._id);
  };

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/total-student-course', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log('GAME', data);
        if (data?.success === false) {
          toast.error(data?.message);
        }
        setState(data?.data);
      })
      .catch((error) => console.error(error));
  }, []);
  const [PushNotification, setPushNotification] = useState(false);

  const handleDeleteClick = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this Request!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');

        const requestOptions = {
          method: 'DELETE',
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(
          `https://quran-backend-theta.vercel.app/v1/user/admissionRequest/${id}`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            let data = JSON.parse(result);

            if (data.success === true) {
              Swal.fire({
                title: 'Deleted!',
                text: 'Your request has been deleted.',
                icon: 'success',
                confirmButtonText: 'OK'
              }).then(() => {
                requestSubmit();
              });
            }
          })
          .catch((error) => {
            console.error(error);
            Swal.fire({
              title: 'Error!',
              text: 'An error occurred while deleting the note.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
          });
      }
    });
  };
  const [isModalStudent, setModalStudent] = useState(false);
  return (
    <Wrapper
      searchBar={
        <Input
          placeholder={`Search by name or course...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <AddDetails setIsModalOpen={setOpen} isModalOpen={open} courseId={courseId} />
      <PushNotifications setIsModalOpen={setPushNotification} isModalOpen={PushNotification} />
      <AddStudents setIsModalOpen={setModalStudent} isModalOpen={isModalStudent} />
      <div className=" flex justify-between items-center">
        <div className=" ">
          <h2 className="main_title ">Dashboard</h2>
          <p className=" text-[#1C1D1D]">Here overview of the courses</p>
        </div>

        <Button
          onClick={() => setPushNotification(true)}
          label={'Mass Push Notifications'}
          className={' text-white'}
        />
      </div>
      <section className=" pt-2">
        <div className=" py-4  w-full grid  grid-cols-1  xl:grid-cols-3 md:grid-cols-2 gap-5">
          <div className=" w-full">
            <div
              className="  bg-white p-5 rounded-lg flex  justify-between"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Active Students</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3  text-[#1C1D1D]">{state?.totalEnrollments}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/active.png')} alt="" />
              </div>
            </div>
          </div>
          <div className=" w-full">
            <div
              className=" bg-white  flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Ongoing Courses</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{state?.totalCourses}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/ongoing.png')} alt="" />
              </div>
            </div>
          </div>
          <div className=" w-full">
            <div
              className=" bg-white  text-black flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Completed</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{totalData?.completed}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/completed.png')} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mb-20 mt-7">
        <div className=" flex pb-5  justify-between items-center">
          <h1 className=" text-xl text-[#1C1D1D] font-semibold">Students Requests</h1>
          <div className=" cursor-pointer" onClick={() => setModalStudent(true)}>
            <img src={require('../../assets/image/add.png')} alt="" />
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-40">
            <div className="loader">
              <h1>Loading, thank you for your patience...</h1>
            </div>
          </div>
        ) : request.length > 0 ? (
          <div className="rounded-lg overflow-x-auto">
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead>
                        <tr className="rounded-lg whitespace-nowrap">
                          <th className="text-sm text-primary font-bold px-6 py-4">Name</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Cource Name</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">
                            Whatsapp's no
                          </th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Phone no</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Country</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredCourses.map((course, index) => (
                          <tr key={index} className="bg-white border-b-8 border-white rounded-md">
                            <td
                              style={{
                                boxShadow: '0px 0px 63.44px 0px #00000012'
                              }}
                              className="align-middle bg-white text-sm font-normal px-6 py-4 whitespace-nowrap text-center"
                            >
                              <span className="text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {course?.name}
                              </span>
                            </td>
                            <td
                              style={{
                                boxShadow: '0px 0px 63.44px 0px #00000012'
                              }}
                              className="align-middle bg-white text-sm font-normal px-6 py-4 whitespace-nowrap text-center"
                            >
                              <span className="text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {course?.course?.name}
                              </span>
                            </td>
                            <td
                              style={{
                                boxShadow: '0px 0px 63.44px 0px #00000012'
                              }}
                              className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap"
                            >
                              <span className="text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {course.whatsappNumber}
                              </span>
                            </td>
                            <td
                              style={{
                                boxShadow: '0px 0px 63.44px 0px #00000012'
                              }}
                              className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left"
                            >
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {course?.phoneNumber}
                              </span>
                            </td>
                            <td
                              style={{
                                boxShadow: '0px 0px 63.44px 0px #00000012'
                              }}
                              className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left"
                            >
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {course.country}
                              </span>
                            </td>
                            <td
                              style={{
                                boxShadow: '0px 0px 63.44px 0px #00000012'
                              }}
                              className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left"
                            >
                              <span className="text-sm text-white leading-none whitespace-nowrap bg-green-200 rounded-full">
                                <img
                                  src={require('../../assets/image/del.png')}
                                  onClick={() => handleDeleteClick(course?._id)}
                                  alt="Delete"
                                  className=" mx-auto"
                                  style={{ cursor: 'pointer' }}
                                />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p className="text-center">No requests found.</p>
        )}
      </section>
    </Wrapper>
  );
};

export default Dashboard;
